class KlaviyoStickyButton extends HTMLElement {
  connectedCallback() {
    if (window.Shopify && window.Shopify.designMode) return;
    this.btn        = this.querySelector('.ksb-btn');
    const rawHash = this.dataset.hash || '#kl-sms-popup';
    this.hashTrigger = rawHash.startsWith('#') ? rawHash : '#' + (new URL(rawHash, location.href).hash.slice(1) || rawHash.split('#')[1] || 'kl-sms-popup');
    this.sessionKey  = 'bp_klaviyo_shown';
    this.dismissKey  = 'bp_klaviyo_sticky_hidden';

    this.querySelector('.ksb-close')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.hide();
      try { sessionStorage.setItem(this.dismissKey, 'true'); } catch (e) {}
    });

    this.btn.addEventListener('click', (e) => {
      if (e.target.closest('.ksb-close')) return;
      this.reopenPopup();
    });

    // If popup was already dismissed in this session, show button right away
    try {
      if (sessionStorage.getItem(this.sessionKey) === 'true') {
        this.show();
        return;
      }
    } catch (e) {}

    this.watchForPopup();
  }

  show() {
    try { if (sessionStorage.getItem(this.dismissKey) === 'true') return; } catch (e) {}
    this.btn?.classList.add('ksb-visible');
  }

  hide() {
    this.btn?.classList.remove('ksb-visible');
  }

  reopenPopup() {
    this.hide();

    const hashName = this.hashTrigger.replace('#', '');

    // Option 1: click the trigger link directly (most reliable, no scroll)
    const triggerLink = document.querySelector(`a[href*="${hashName}"]`);
    if (triggerLink) {
      triggerLink.click();
      this.waitForPopupThenWatchClose();
      return;
    }

    // Option 2: pushState (no scroll) + hashchange event
    if (window.location.hash === this.hashTrigger) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    setTimeout(() => {
      history.pushState(null, '', this.hashTrigger);
      try { window.dispatchEvent(new HashChangeEvent('hashchange')); } catch (e) {
        const evt = document.createEvent('Event');
        evt.initEvent('hashchange', true, true);
        window.dispatchEvent(evt);
      }
      setTimeout(() => {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }, 1500);
    }, 100);

    this.waitForPopupThenWatchClose();
  }

  watchForPopup() {
    let popupWasVisible = false;

    // MutationObserver for popup appearing
    const observer = new MutationObserver(() => {
      const popup = this.findPopup();
      if (!popup) return;
      const cs = window.getComputedStyle(popup);
      const visible = cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
      if (visible && !popupWasVisible) {
        popupWasVisible = true;
        this.watchPopupClose(popup, observer);
      }
    });

    observer.observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['style', 'class', 'aria-hidden']
    });

    // Polling fallback
    const poll = setInterval(() => {
      if (sessionStorage.getItem(this.sessionKey) === 'true') { clearInterval(poll); return; }
      const popup = this.findPopup();
      if (popup) {
        const cs = window.getComputedStyle(popup);
        const visible = cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
        if (visible) popupWasVisible = true;
        else if (popupWasVisible) { this.onPopupDismissed(); clearInterval(poll); }
      } else if (popupWasVisible) {
        this.onPopupDismissed(); clearInterval(poll);
      }
    }, 500);
  }

  watchPopupClose(popup, parentObserver) {
    if (parentObserver) parentObserver.disconnect();

    const onClose = () => { this.onPopupDismissed(); closeObserver.disconnect(); };

    const closeObserver = new MutationObserver(() => {
      if (!document.body.contains(popup)) { onClose(); return; }
      const cs = window.getComputedStyle(popup);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') onClose();
    });

    closeObserver.observe(popup, { attributes: true, attributeFilter: ['style', 'class', 'aria-hidden'] });
    if (popup.parentNode) closeObserver.observe(popup.parentNode, { childList: true });

    // Polling fallback
    const poll = setInterval(() => {
      if (!document.body.contains(popup)) { clearInterval(poll); closeObserver.disconnect(); this.onPopupDismissed(); return; }
      const cs = window.getComputedStyle(popup);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') {
        clearInterval(poll); closeObserver.disconnect(); this.onPopupDismissed();
      }
    }, 500);
  }

  waitForPopupThenWatchClose() {
    let attempts = 0;
    const check = setInterval(() => {
      attempts++;
      if (attempts > 20) { clearInterval(check); this.show(); return; }
      const popup = this.findPopup();
      if (!popup) return;
      const cs = window.getComputedStyle(popup);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0') {
        clearInterval(check);
        this.watchPopupClose(popup, null);
      }
    }, 300);
  }

  onPopupDismissed() {
    try { sessionStorage.setItem(this.sessionKey, 'true'); } catch (e) {}
    this.show();
  }

  findPopup() {
    // Primary: fixed dialog with high z-index
    const dialogs = document.querySelectorAll('div[role="dialog"][aria-modal="true"]');
    for (const el of dialogs) {
      const cs = window.getComputedStyle(el);
      if (cs.position === 'fixed' && parseInt(cs.zIndex, 10) > 999) return el;
    }
    // Fallbacks
    for (const sel of ['div[data-testid="POPUP"]', 'div[class*="needsOffsetAccountedFor"]', 'form[data-testid*="klaviyo-form"]']) {
      try {
        const el = document.querySelector(sel);
        if (el) return el;
      } catch (e) {}
    }
    return null;
  }
}

customElements.define('klaviyo-sticky-button', KlaviyoStickyButton);
